/**
 * Whether a file satisfies an input `accept` attribute.
 *
 * The browser applies `accept` to the file picker only — a drop or a paste is unfiltered, so this
 * has to exist for those two routes to behave like the third.
 */
export const acceptsFile = (file: File, accept: string): boolean =>
  accept
    .split(",")
    .map((rule) => rule.trim().toLowerCase())
    .filter(Boolean)
    .some((rule) => {
      if (rule.startsWith(".")) return file.name.toLowerCase().endsWith(rule);
      if (rule.endsWith("/*")) return file.type.startsWith(rule.slice(0, -1));
      return file.type.toLowerCase() === rule;
    });
